import {sendRequest} from "./Sender";

export const ClientService = {
    GetList,
    Create,
    GetById,
    GetCount,
    Delete,
    ChangeStatus,
    Update,
    AddComment,
    UpdateParents,
    UpdateContracts,
    UpdateChild,
    Read
}

function GetList(params= [], expand = ''){
    return sendRequest('clients', 'GET', {...params, 'expand': expand}, true)
}

function Create(data){
    return sendRequest('clients', 'POST', data)
}

function GetById(id, expand = ''){
    return sendRequest('clients/'  + id, 'GET', {'expand': expand}, true)
}

function GetCount(params= []){
    return sendRequest('clients/count', 'GET', {...params}, true)
}

function Delete(id){
    return sendRequest('clients/' + id, 'DELETE', {}, true)
}
function ChangeStatus(id, type, status){
    return sendRequest('clients/change-status', 'POST', {'id': id, 'type': type, 'status': status}, true)
}
function Update(id, data){
    return sendRequest('clients/' + id, 'PUT', {...data})
}
function Read(id){
    return sendRequest('clients/read', 'POST', {'id' : id}, true)
}
function AddComment(id, user_id, comment, data){
    return sendRequest('clients/add-comment', 'POST', {'author_id': user_id, 'object_id': id, 'text': comment, ...data}, true)
}

function UpdateParents(id, data){
    return sendRequest('clients/update-contacts/' + id, 'POST', {...data}, true)

}
function UpdateContracts(id, data, type){
    return sendRequest('clients/update-contracts/' + id + '/' + type, 'POST', {...data}, true)

}
function UpdateChild(id, data){
    return sendRequest('clients/update-child/' + id, 'POST', {...data}, true)

}